import { Amplify } from 'aws-amplify';

const authConfig = {
  Cognito: {
    userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
    userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
  },
};

// OAuth config is only added when the Cognito domain env var is set.
// This allows the app to work without Google login configured.
if (process.env.REACT_APP_COGNITO_DOMAIN) {
  authConfig.Cognito.loginWith = {
    oauth: {
      domain: process.env.REACT_APP_COGNITO_DOMAIN,
      scopes: ['openid', 'email', 'profile'],
      redirectSignIn: [process.env.REACT_APP_OAUTH_REDIRECT_SIGN_IN || 'https://app.bragsheet.io'],
      redirectSignOut: [process.env.REACT_APP_OAUTH_REDIRECT_SIGN_OUT || 'https://app.bragsheet.io'],
      responseType: 'code',
    },
  };
}

Amplify.configure({
  Auth: authConfig,
});
